var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-input'),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.handleIndex}},[_vm._v("确定")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }